import * as React from 'react';
import { UniqueRequestType } from '../models/unique-request';
import { Box } from '@mui/material';
import { Chip } from '@material-ui/core';
import { alpha, useTheme } from '@mui/material/styles';

export const UniqueRequestTypeChip = ({
    type,
}: {
    type: UniqueRequestType;
}) => {
    const theme = useTheme();

    const { backgroundColor, label } = (() => {
        switch (type) {
            case UniqueRequestType.Document:
                return {
                    backgroundColor: theme.palette.orange['500'],
                    label: 'Változásbejelentés',
                };

            case UniqueRequestType.DebtFree:
                return {
                    backgroundColor: theme.palette.blue['500'],
                    label: 'Tartozásmentességi...',
                };

            case UniqueRequestType.Unique:
                return {
                    backgroundColor: theme.palette.purple['600'],
                    label: 'Egyedi',
                };

            default:
                return {
                    backgroundColor: theme.palette.error.main,
                    label: '-',
                };
        }
    })();

    return (
        <Box display="flex" alignItems="center">
            <Chip
                variant="outlined"
                style={{
                    backgroundColor: alpha(backgroundColor, 0.1),
                    borderColor: backgroundColor,
                    color: backgroundColor,
                    width: 175,
                }}
                label={label}
            />
        </Box>
    );
};
